import React, { Component } from "react";
import { Api } from "../utils/api";
import { withRouter } from "react-router";
import { PlanDetailsCard } from "../components/plan_detail_card.component";
import EntityUsersTable from "./components/entity_users_table.component";
import EntityPlansTable from "./components/entity_plans_table.component";
import { EntityMainForm } from "./forms/entity-main.form";
import {
  Typography,
  CircularProgress,
  FormControlLabel,
  FormGroup,
} from "@material-ui/core";
import AlertDialog from "../components/alert.component";
import Switch from "@material-ui/core/Switch";
import moment from "moment";
import Grid from "@material-ui/core/Grid";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import Button from "@material-ui/core/Button";

import ToolsButton from "../components/tools_button.component";

const CONTROL_REGIST_MAP = {
  PaymentsControl: "Desativar próximas cobranças",
  AccessToRequestsControl: "Desativar acesso a pedidos",
  DispersedRequestsControl: "Aceita pedidos dispersos",
  ExclusiveRequestsControl: "Aceita pedidos encaminhados",
  ForceRequestsControl: "Com potencial de angariação",
  AutoAcceptControl: "Encaminhamento imediato",
  LimitEstablishmentRequestsControl: "Limite 3 pedidos mensais",
  ShowElderlyNameControl: "Esconder nome do idoso",
  FreePlanControl: "Plano oferta",
};

class EntitiesView extends Component {
  state = {
    userRole: null,
    entities: null,
    entity: null,
    entityGroupId: null,
    entityGroupName: null,
    easypayReference: null,
    entityPlan: null,
    users: null,
    entityPlans: null,
    showAlert: false,
    alertTitle: "",
    alertMessage: "",
    isActive: false,
    disablePayments: true,
    disableAccessToRequests: false,
    acceptDisperseRequests: false,
    forceRequests: false,
    acceptExclusiveRequests: true,
    noReqMotives: null,
    forceReqMotives: null,
    establishmentsFromEntity: null,
    add_to_new_group: null,
    remove_from_group: null,
    add_to_group: null,
    profissionalUsers: null,
    limitEstablishmentsRequests: false,
    freePlan: true,
    entityControlsRegists: null,
    lastControlsRegist: null,
    autoAccept: null,
    estReqIdsNotAccepted: null,
  };

  constructor() {
    super();
    this.api = new Api();
    this.getUserRole = this.getUserRole.bind(this);
    this.getEntity = this.getEntity.bind(this);
    this.getEntityGroup = this.getEntityGroup.bind(this);
    this.getEasypayReference = this.getEasypayReference.bind(this);
    this.getEntityPlan = this.getEntityPlan.bind(this);
    this.getEntityContacts = this.getEntityContacts.bind(this);
    this.getEntityPlans = this.getEntityPlans.bind(this);
    this.getNoReqMotives = this.getNoReqMotives.bind(this);
    this.getForceReqMotives = this.getForceReqMotives.bind(this);
    this.updateEntity = this.updateEntity.bind(this);
    this.createUser = this.createUser.bind(this);
    this.updateUser = this.updateUser.bind(this);
    this.deleteUser = this.deleteUser.bind(this);
    this.createEntityPlan = this.createEntityPlan.bind(this);
    this.updateEntityPlan = this.updateEntityPlan.bind(this);
    this.deleteEntityPlan = this.deleteEntityPlan.bind(this);
    this.deleteEntity = this.deleteEntity.bind(this);
    this.changeEasypayReference = this.changeEasypayReference.bind(this);
    this.changePlanDisableDate = this.changePlanDisableDate.bind(this);
    this.changeDisperseRequests = this.changeDisperseRequests.bind(this);
    this.changeForceRequests = this.changeForceRequests.bind(this);
    this.changeExclusiveRequests = this.changeExclusiveRequests.bind(this);
    this.showAlert = this.showAlert.bind(this);
    this.showAlertDeleteEntity = this.showAlertDeleteEntity.bind(this);
    this.closeAlert = this.closeAlert.bind(this);
    this.limitEstablishmentsRequests =
      this.limitEstablishmentsRequests.bind(this);
    this.toggleControlsHistory = this.toggleControlsHistory.bind(this);
    this.getAllControlsHistoryRegists =
      this.getAllControlsHistoryRegists.bind(this);
    this.getLastControlsRegist = this.getLastControlsRegist.bind(this);
    this.getHistoryRegistsOrderByControl =
      this.getHistoryRegistsOrderByControl.bind(this);
    this.handleAutoAccept = this.handleAutoAccept.bind(this);
    this.handleFreePlan = this.handleFreePlan.bind(this);
    this.handleShowElderlyName = this.handleShowElderlyName.bind(this);
    this.getEstValenceIdsFromEntity =
      this.getEstValenceIdsFromEntity.bind(this);
    this.changeSentRequestsToAccepted =
      this.changeSentRequestsToAccepted.bind(this);
  }

  /**
   *
   */

  async componentDidMount() {
    const { id } = this.props.match.params;
    await this.getUserRole();
    await this.getEntity(id);
    await this.getLastControlsRegist();
    this.getEasypayReference(id);
    this.getEntityPlan(id);
    this.getEntityContacts(id);
    this.getEntityPlans(id);
    this.getEntityGroup();
    this.getNoReqMotives();
    this.getForceReqMotives();
  }

  showAlert(title, message) {
    this.setState({ showAlert: true });
    this.setState({ alertTitle: title });
    this.setState({ alertMessage: message });
  }

  showAlertDeleteEntity() {
    this.setState({ showAlert: true });
    this.setState({ alertTitle: <p>Eliminar entidade</p> });
    this.setState({
      alertMessage: (
        <div>
          <p>
            Tem a certeza que deseja eliminar esta entidade e equipamentos
            pertencentes (o histórico de faturação continuará visível)?
          </p>
          <p className="text-center mt-4">
            <Button
              className="button_delete_entity_or_establishment"
              onClick={this.deleteEntity}
            >
              Sim
            </Button>
          </p>
        </div>
      ),
    });
  }

  closeAlert() {
    this.setState({ showAlert: false });
  }

  // obter o role do user logado
  getUserRole = () => {
    this.api
      .get(`/admins/${localStorage.id}`, {}, true)
      .then(({ data: admin }) => {
        this.setState({ userRole: admin.id_group });
      });
  };

  async getEntity(entity_id) {
    await this.api.get(`entities/${entity_id}`).then(({ data = null }) => {
      this.setState({
        entity: data,
        isActive: data.active,
        acceptDisperseRequests: data.dispersed_requests,
        forceRequests: data.force_requests,
        acceptExclusiveRequests: data.exclusive_requests,
        showElderlyName: data.show_elderly_name,
        entityGroupId: data.group_id,
        limitEstablishmentsRequests: data.limit_establishments_requests,
        autoAccept: data.request_mode === "auto_accept",
        freePlan: data.free_plan
      });
    });
  }

  //ir buscar a lista dos equipamentos q pertencem a x grupo, bem como o nome do grupo
  getEntityGroup() {
    let entity_group_id = this.state.entityGroupId;
    if (entity_group_id) {
      this.api
        .get(`/entity_groups`, { id: entity_group_id })
        .then(({ data = null }) => {
          this.setState({ entityGroupName: data });
        });
    }
  }

  getNoReqMotives() {
    return this.api.get("/no_requests_motives").then(({ data = null }) => {
      this.setState({ noReqMotives: data });
      return data;
    });
  }

  getForceReqMotives() {
    return this.api.get("/force_requests_motives").then(({ data = null }) => {
      this.setState({ forceReqMotives: data });
      return data;
    });
  }

  updateEntity(entity) {
    return this.api
      .patch(`entities/${entity.id}`, { ...entity })
      .then(({ data = null }) => {
        this.setState({ entity: data });
        this.setState({
          showAlert: true,
          alertTitle: "Sucesso",
          alertMessage: "Dados atualizados com sucesso",
        });
        return data;
      })
      .catch(({ data = null }) => {
        this.setState({ entity: data });
        this.setState({
          showAlert: true,
          alertTitle: "Erro",
          alertMessage: "Ocorreu um erro",
        });
        return data;
      });
  }

  getEasypayReference(entity_id) {
    return this.api
      .get(`easypay_references`, { entity_id: entity_id })
      .then(({ data = null }) => {
        if (!data) return;
        this.setState({ easypayReference: data });
        this.setState({ disablePayments: data.active ? false : true });
        this.setState({
          disableAccessToRequests:
            !data.active || moment(data.disable_plan_at).isBefore(new Date())
              ? true
              : false,
        });
        return data;
      });
  }

  createEasypayReference(disable_plan_at = null) {
    const entity_id = this.state.entityPlan.entity_id;
    const plan_id = this.state.entityPlan.plan_id;
    let ep_reference = {
      entity_id,
      plan_id,
      ep_cin: 100387,
      ep_entity: 100387,
      ep_reference: 0,
      ep_value: 0,
      disable_plan_at: disable_plan_at,
      active: 0,
    };
    return this.api
      .post(`easypay_references/`, ep_reference)
      .then(({ data: easypayReference }) => {
        //TODO: validate
        return this.updateEntityPlan({
          id: this.state.entityPlan.id,
          easypay_reference_id: easypayReference.id,
        });
      });
  }

  getEntityPlan(entity_id) {
    return this.api
      .get(`entity_plans`, { entity_id, last: true })
      .then(({ data = null }) => {
        if (!data) return;
        this.setState({ entityPlan: data });
        return data;
      });
  }

  getEntityContacts(entity_id) {
    return this.api
      .get(`users`, { entity_id: entity_id })
      .then(({ data = null }) => {
        this.setState({ users: data });
        return data;
      });
  }

  getEntityPlans(entity_id) {
    return this.api
      .get(`entity_plans`, { entity_id: entity_id })
      .then(({ data = null }) => {
        this.setState({ entityPlans: data });
        return data;
      });
  }

  createUser(post_data) {
    return this.api.post(`users`, { ...post_data }).then(({ data = null }) => {
      var newUser = data;
      post_data.user_id = newUser.id;
      return this.api.post(`user_entities`, { ...post_data });
    });
  }

  updateUser(patch_data) {
    return this.api
      .patch(`users/${patch_data.id}`, { ...patch_data })
      .then(({ data = null }) => {
        patch_data.id = patch_data.user_entity_id;
        return this.api.patch(`user_entities/${patch_data.id}`, {
          ...patch_data,
        });
      });
  }

  deleteUser(data) {
    return this.api.delete(`users/${data.id}`, { ...data });
  }

  createEntityPlan(post_data) {
    return this.api.post(`entity_plans`, { ...post_data });
  }

  updateEntityPlan(patch_data) {
    return this.api.patch(`entity_plans/${patch_data.id}`, { ...patch_data });
  }

  deleteEntityPlan(data) {
    return this.api.delete(`entity_plans/${data.id}`, { ...data });
  }

  // BOTAO Eliminar entidade (desaparece do site e do BO - excepto historico de facturaçao no BO)
  async deleteEntity() {
    const { id } = this.props.match.params;
    //receber os equipamentos de uma determinada entidade
    await this.api
      .get(`establishments`, {
        entity_id: id,
        establishments_from_entity: true,
      })
      .then(({ data = null }) => {
        this.setState({ establishmentsFromEntity: data });
      });
    //alterar valor na página de equipamentos da entidade (Ativo e Publicado)
    for (let i = 0; i < this.state.establishmentsFromEntity.length; i++) {
      try {
        this.api.patch(
          `establishment_valences/${this.state.establishmentsFromEntity[i].establishments_valences_id}`,
          { is_active: 0, is_published: 0 }
        );
      } catch (err) {
        console.log(err);
      }
    }
    //alterar ativo do equipamento
    this.api
      .patch(`entities/${id}`, { is_active: 0 })
      .then(
        this.setState({
          showAlert: true,
          alertTitle: "Sucesso",
          alertMessage: "Eliminado com sucesso",
        })
      )
      .then(window.location.replace("/entities"));
  }

  //BOTAO DESATIVAR PROXIMAS COBRANÇAS
  async changeEasypayReference() {
    const entity_id = this.props.match.params.id;
    let easypayRef = this.state.easypayReference;
    if (easypayRef.active) {
      easypayRef.active = 0;
      this.api.post(`entity_controls_regists`, {
        user_id: localStorage.id,
        entity_id: entity_id,
        control: "PaymentsControl",
        status: 1,
        ord: 5,
      });
      this.api.post(`entity_controls_regists`, {
        user_id: localStorage.id,
        entity_id: entity_id,
        control: "AccessToRequestsControl",
        status: 1,
        ord: 4,
      });
      if (!this.state.disableAccessToRequests) {
        document.getElementById("no-requests-select").value = 2; //TODO: not working..
        await this.handleChangeNoReqMotive({ target: { value: 2 } }, false);
      }
    } else {
      this.api.post(`entity_controls_regists`, {
        user_id: localStorage.id,
        entity_id: entity_id,
        control: "PaymentsControl",
        status: 0,
        ord: 5,
      });
      this.api.post(`entity_controls_regists`, {
        user_id: localStorage.id,
        entity_id: entity_id,
        control: "AccessToRequestsControl",
        status: 0,
        ord: 4,
      });
      easypayRef.active = 1;
    }
    //
    await this.api.patch(`easypay_references/${easypayRef.id}`, {
      active: easypayRef.active,
    });
    await this.getEasypayReference(entity_id);
    await this.getLastControlsRegist();
    this.showAlert("Sucesso", "Alterado com sucesso!");
  }

  //BOTAO PEDIDOS DISPERSOS
  changeDisperseRequests() {
    let entity = this.state.entity;
    if (this.state.acceptDisperseRequests === false) {
      this.setState({ acceptDisperseRequests: true });
      this.api.post(`entity_controls_regists`, {
        user_id: localStorage.id,
        entity_id: entity.id,
        control: "DispersedRequestsControl",
        status: 1,
        ord: 1,
      });
      this.api
        .patch(`entities/${entity.id}`, { dispersed_requests: 1 })
        .then((res) => {
          this.getLastControlsRegist();
          this.showAlert("Sucesso", "Alterado com sucesso!");
        });
    } else {
      this.setState({ acceptDisperseRequests: false });
      this.api.post(`entity_controls_regists`, {
        user_id: localStorage.id,
        entity_id: entity.id,
        control: "DispersedRequestsControl",
        status: 0,
        ord: 1,
      });
      this.api
        .patch(`entities/${entity.id}`, { dispersed_requests: 0 })
        .then((res) => {
          this.getLastControlsRegist();
          this.showAlert("Sucesso", "Alterado com sucesso!");
        });
    }
  }

  //BOTAO DESATIVAR PEDIDOS
  changePlanDisableDate() {
    let entity_id = this.props.match.params.id;
    let easypayRef = this.state.easypayReference;
    let no_req_div = document.getElementById("no_req_div");
    let no_req_p = document.getElementById("no_req_p");

    if (easypayRef === null) {
      let disable_plan_at_null = null;
      this.createEasypayReference(disable_plan_at_null)
        .then(() => {
          this.getEasypayReference(entity_id);
        })
        .then(() => {
          no_req_div.classList.remove("d-none");
          no_req_p.classList.remove("d-none");
        });
    } else {
      this.getEasypayReference(entity_id).then(() => {
        if (
          this.state.disableAccessToRequests === false &&
          easypayRef.no_req_motive_id === null
        ) {
          no_req_div.classList.remove("d-none");
          no_req_p.classList.remove("d-none");
        } else {
          this.setState({ disableAccessToRequests: false });
          no_req_div.classList.add("d-none");
          no_req_p.classList.add("d-none");
          document.getElementById("no-requests-select").innerText = "";
          if (
            this.state.lastControlsRegist.find(
              (lc) => lc.control === "AutoAcceptControl"
            ).status === 0 &&
            this.state.autoAccept === false
          ) {
            this.setState({ autoAccept: true });
            this.api
              .patch(`entities/${entity_id}`, { request_mode: "auto_accept" })
              .then(() =>
                this.api.post(`entity_controls_regists`, {
                  user_id: localStorage.id,
                  entity_id: entity_id,
                  control: "AutoAcceptControl",
                  status: 1,
                  ord: 6,
                })
              );
          }
          if (easypayRef.plan_id > 1 && easypayRef.entity_plan_active === 1) {
            this.api.patch(`easypay_references/${easypayRef.id}`, {
              active: 1,
            });
          }
          this.api.post(`entity_controls_regists`, {
            user_id: localStorage.id,
            entity_id: entity_id,
            control: "AccessToRequestsControl",
            status: 0,
            ord: 4,
          });
          this.api.patch(`easypay_references/${easypayRef.id}`, {
            disable_plan_at: null,
          });
          this.api
            .patch(`/easypay_references/${easypayRef.id}`, {
              no_req_motive_id: null,
            })
            .then(() => {
              this.setState({ disableAccessToRequests: false });
              this.getEasypayReference(entity_id);
              this.getEntity(entity_id);
              this.getLastControlsRegist();
              this.showAlert("Sucesso", "Alterado com sucesso!");
            });
        }
      });
    }
  }

  //INPUT MOTIVOS P/DESATIVAR PEDIDOS
  handleChangeNoReqMotive = (event, withDate = true) => {
    const disable_plan_at = withDate
      ? moment(moment.now()).subtract(1, "days")
      : null;
    let easypayRef = this.state.easypayReference;
    let entity_id = this.props.match.params.id;
    let no_req_input = document.getElementById("no-requests-select");
    no_req_input = event.target.value;

    this.getEasypayReference(entity_id).then(() => {
      if (easypayRef && easypayRef.no_req_motive_id === null) {
        if (easypayRef) {
          this.setState({ disableAccessToRequests: true });
          this.setState({ autoAccept: false });
          this.api
            .patch(`entities/${entity_id}`, { request_mode: "classic" })
            .then(() => {
              this.api.post(`entity_controls_regists`, {
                user_id: localStorage.id,
                entity_id: entity_id,
                control: "AutoAcceptControl",
                status: 0,
                ord: 6,
              });
              this.api.post(`entity_controls_regists`, {
                user_id: localStorage.id,
                entity_id: entity_id,
                control: "AccessToRequestsControl",
                status: 1,
                ord: 4,
              });
            });
          this.api.patch(`/easypay_references/${easypayRef.id}`, {
            no_req_motive_id: no_req_input,
          });
          this.api.patch(`easypay_references/${easypayRef.id}`, {
            disable_plan_at,
          });
          this.getEasypayReference(entity_id).then((res) => {
            this.setState({ disableAccessToRequests: true });
            this.getLastControlsRegist().then(() => {
              this.getEasypayReference(entity_id);
              this.showAlert("Sucesso", "Alterado com sucesso!");
            });
          });
        } else {
          this.setState({ disableAccessToRequests: true });
          this.setState({ autoAccept: false });
          this.api
            .patch(`entities/${entity_id}`, { request_mode: "classic" })
            .then(() => {
              this.api.post(`entity_controls_regists`, {
                user_id: localStorage.id,
                entity_id: entity_id,
                control: "AutoAcceptControl",
                status: 0,
                ord: 6,
              });
              this.api.post(`entity_controls_regists`, {
                user_id: localStorage.id,
                entity_id: entity_id,
                control: "AccessToRequestsControl",
                status: 1,
                ord: 4,
              });
            });
          this.createEasypayReference(disable_plan_at);
          this.api.patch(`/easypay_references/${easypayRef.id}`, {
            no_req_motive_id: no_req_input,
          });
          this.getEasypayReference(entity_id).then(() => {
            this.setState({ disableAccessToRequests: true });
            this.getLastControlsRegist().then(() => {
              this.getEasypayReference(entity_id);
              this.showAlert("Sucesso", "Alterado com sucesso!");
            });
          });
        }
      } else {
        this.setState({ disableAccessToRequests: false });
        this.api.post(`entity_controls_regists`, {
          user_id: localStorage.id,
          entity_id: entity_id,
          control: "AccessToRequestsControl",
          status: 0,
          ord: 4,
        });
        this.getLastControlsRegist();
        this.api.patch(`easypay_references/${easypayRef.id}`, {
          no_req_motive_id: null,
        });
        this.api
          .patch(`easypay_references/${easypayRef.id}`, {
            disable_plan_at: null,
          })
          .then(() => {
            this.setState({ disableAccessToRequests: false }).then(() => {
              this.getEasypayReference(entity_id);
              this.showAlert("Sucesso", "Alterado com sucesso!");
            });
          });
      }
    });
  };

  //BOTAO POTENCIAL DE ANGARIAÇAO
  changeForceRequests() {
    let entity = this.state.entity;
    let force_req_div = document.getElementById("force_req_div");
    let force_req_p = document.getElementById("force_req_p");
    const { id } = this.props.match.params;

    this.getEntity(id).then((res) => {
      if (
        this.state.forceRequests === false &&
        entity.force_req_motive_id === null
      ) {
        force_req_div.classList.remove("d-none");
        force_req_p.classList.remove("d-none");
      } else {
        this.setState({ forceRequests: false });
        force_req_div.classList.add("d-none");
        force_req_p.classList.add("d-none");
        this.api.patch(`/entities/${id}`, { force_req_motive_id: null });
        this.api.patch(`entities/${entity.id}`, { force_requests: 0 });
        this.api.post(`entity_controls_regists`, {
          user_id: localStorage.id,
          entity_id: entity.id,
          control: "ForceRequestsControl",
          status: 0,
          ord: 3,
        });
        document.getElementById("force-requests-select").innerText = "";
        this.getEntity(id).then((res) => {
          this.getLastControlsRegist();
          this.showAlert("Sucesso", "Alterado com sucesso!");
        });
      }
    });
  }

  //INPUT MOTIVOS POTENCIAL DE ANGARIAÇAO
  handleChangeForceReqMotive = (event) => {
    const { id } = this.props.match.params;
    let force_req_input = document.getElementById("force-requests-select");
    force_req_input = event.target.value;
    this.api.patch(`/entities/${id}`, { force_req_motive_id: force_req_input });
    this.api.patch(`entities/${id}`, { force_requests: 1 });
    this.api.patch(`entities/${id}`, { exclusive_requests: 1 });
    this.api.post(`entity_controls_regists`, {
      user_id: localStorage.id,
      entity_id: id,
      control: "ForceRequestsControl",
      status: 1,
      ord: 3,
    });
    this.api.post(`entity_controls_regists`, {
      user_id: localStorage.id,
      entity_id: id,
      control: "ExclusiveRequestsControl",
      status: 1,
      ord: 2,
    });
    this.setState({ forceRequests: true });
    this.setState({ acceptExclusiveRequests: true });
    this.getEntity(id).then((res) => {
      this.getLastControlsRegist();
      this.showAlert("Sucesso", "Alterado com sucesso!");
    });
  };

  //BOTAO ACEITA PEDIDOS ENCAMINHADOS
  changeExclusiveRequests() {
    let entity = this.state.entity;
    if (this.state.acceptExclusiveRequests === false) {
      this.setState({ acceptExclusiveRequests: true });
      this.api.post(`entity_controls_regists`, {
        user_id: localStorage.id,
        entity_id: entity.id,
        control: "ExclusiveRequestsControl",
        status: 1,
        ord: 2,
      });
      this.api
        .patch(`entities/${entity.id}`, { exclusive_requests: 1 })
        .then((res) => {
          this.getLastControlsRegist();
          this.showAlert("Sucesso", "Alterado com sucesso!");
        });
    } else {
      this.setState({ acceptExclusiveRequests: false });
      this.setState({ forceRequests: false });
      this.api.patch(`entities/${entity.id}`, { force_requests: 0 });
      this.api.patch(`/entities/${entity.id}`, { force_req_motive_id: null });
      this.api.post(`entity_controls_regists`, {
        user_id: localStorage.id,
        entity_id: entity.id,
        control: "ExclusiveRequestsControl",
        status: 0,
        ord: 2,
      });
      this.api.post(`entity_controls_regists`, {
        user_id: localStorage.id,
        entity_id: entity.id,
        control: "ForceRequestsControl",
        status: 0,
        ord: 3,
      });
      this.api
        .patch(`entities/${entity.id}`, { exclusive_requests: 0 })
        .then((res) => {
          this.getLastControlsRegist();
          this.showAlert("Sucesso", "Alterado com sucesso!");
        });
    }
  }

  limitEstablishmentsRequests() {
    let entity = this.state.entity;
    if (this.state.limitEstablishmentsRequests === false) {
      this.setState({ limitEstablishmentsRequests: true });
      this.api
        .patch(`entities/${entity.id}`, { limit_establishments_requests: 1 })
        .then(() =>
          this.api.post(`entity_controls_regists`, {
            user_id: localStorage.id,
            entity_id: entity.id,
            control: "LimitEstablishmentRequestsControl",
            status: 1,
            ord: 7,
          })
        )
        .then(() => {
          this.getLastControlsRegist();
          this.showAlert("Sucesso", "Ativado com sucesso!");
        });
    } else {
      this.setState({ limitEstablishmentsRequests: false });
      this.api
        .patch(`entities/${entity.id}`, { limit_establishments_requests: 0 })
        .then(() =>
          this.api.post(`entity_controls_regists`, {
            user_id: localStorage.id,
            entity_id: entity.id,
            control: "LimitEstablishmentRequestsControl",
            status: 0,
            ord: 7,
          })
        )
        .then(() => {
          this.getLastControlsRegist();
          this.showAlert("Sucesso", "Desativado com sucesso!");
        });
    }
  }

  // BOTAO ENCAMINHAMENTO IMEDIATO
  handleAutoAccept() {
    let entity = this.state.entity;
    if (this.state.autoAccept === false) {
      this.setState({ autoAccept: true });
      this.api
        .patch(`entities/${entity.id}`, { request_mode: "auto_accept" })
        .then(() =>
          this.api.post(`entity_controls_regists`, {
            user_id: localStorage.id,
            entity_id: entity.id,
            control: "AutoAcceptControl",
            status: 1,
            ord: 6,
          })
        )
        .then(this.getEstValenceIdsFromEntity())
        .then(() => {
          this.getLastControlsRegist().then(() => {
            this.getEntity(entity.id);
            this.showAlert("Sucesso", "Ativado com sucesso!");
          });
        });
    } else {
      this.setState({ autoAccept: false });
      this.api
        .patch(`entities/${entity.id}`, { request_mode: "classic" })
        .then(() =>
          this.api.post(`entity_controls_regists`, {
            user_id: localStorage.id,
            entity_id: entity.id,
            control: "AutoAcceptControl",
            status: 0,
            ord: 6,
          })
        )
        .then(() => {
          this.getLastControlsRegist().then(() => {
            this.getEntity(entity.id);
            this.showAlert("Sucesso", "Ativado com sucesso!");
          });
        });
    }
  }

  handleFreePlan() {
    let entity = this.state.entity;
    const { freePlan } = this.state;

    this.setState({ freePlan: !freePlan });
    this.api
      .patch(`entities/${entity.id}`, { free_plan: !freePlan })
      .then(() =>
        this.api.post(`entity_controls_regists`, {
          user_id: localStorage.id,
          entity_id: entity.id,
          control: "FreePlanControl",
          status: !freePlan,
          ord: 6,
        })
      )
      .then(() => {
        this.getLastControlsRegist().then(() => {
          this.getEntity(entity.id);
          this.showAlert("Sucesso", "Ativado com sucesso!");
        });
      });
  }

  handleShowElderlyName() {
    let entity = this.state.entity;
    if (this.state.showElderlyName === false) {
      this.setState({ showElderlyName: true });
      this.api
        .patch(`entities/${entity.id}`, { show_elderly_name: true })
        .then(() =>
          this.api.post(`entity_controls_regists`, {
            user_id: localStorage.id,
            entity_id: entity.id,
            control: "ShowElderlyNameControl",
            status: 0,
            ord: 6,
          })
        )
        .then(() => {
          this.getLastControlsRegist().then(() => {
            this.getEntity(entity.id);
            this.showAlert("Sucesso", "Desativado com sucesso!");
          });
        });
    } else {
      this.setState({ showElderlyName: false });
      this.api
        .patch(`entities/${entity.id}`, { show_elderly_name: false })
        .then(() =>
          this.api.post(`entity_controls_regists`, {
            user_id: localStorage.id,
            entity_id: entity.id,
            control: "ShowElderlyNameControl",
            status: 1,
            ord: 6,
          })
        )
        .then(() => {
          this.getLastControlsRegist().then(() => {
            this.getEntity(entity.id);
            this.showAlert("Sucesso", "Ativado com sucesso!");
          });
        });
    }
  }

  getEstValenceIdsFromEntity = async () => {
    let entity = this.state.entity;
    let from_entity = true;
    let estValenceIdsFromEntity = [];
    //ir buscar os ids do establishment_valence com base na entidade
    const res = await this.api.get(`establishment_valences`, {
      entity_id: entity.id,
      from_entity,
    });
    const res_data = res.data;
    //colocar esses ids do establishment_valence para dentro do mesmo array
    res_data.forEach((resd) => {
      estValenceIdsFromEntity.push(resd.id);
    });
    this.changeSentRequestsToAccepted(estValenceIdsFromEntity);
  };

  //mudar encaminhamentos da entidade para aceites
  changeSentRequestsToAccepted = async (estValenIdArray) => {
    let sent_requests = true;
    //vai buscar os ids dos establishments_requests
    //e faz update dos pedidos encaminhados para aceites (apesar de ser um get, no BE faz um update)
    await this.api.get(`establishment_requests`, {
      establishment_valence_id: estValenIdArray,
      sent_requests,
    });
  };

  toggleControlsHistory() {
    let order_by_control = false;
    this.getAllControlsHistoryRegists(order_by_control);
    const element = document.getElementById("controls-history-description");
    element.classList.toggle("d-none");
  }

  getHistoryRegistsOrderByControl() {
    let order_by_control = true;
    this.getAllControlsHistoryRegists(order_by_control);
  }

  //mostrar historico de todos os registos de alteraçoes de controlos - so faz a chamada qd se clica no botao
  getAllControlsHistoryRegists(order_by_control) {
    return this.api
      .get("/entity_controls_regists", {
        entity_id: this.props.match.params.id,
        order_by_control,
      })
      .then(({ data = null }) => {
        this.setState({ entityControlsRegists: data });
        return data;
      });
  }

  //mostrar ultima alteraçao, agrupada por controlo
  getLastControlsRegist() {
    return this.api
      .get("/entity_controls_regists", {
        entity: this.props.match.params.id,
        last_regist: true,
      })
      .then(({ data = null }) => {
        this.setState({ lastControlsRegist: data });
        return data;
      });
  }

  /**
   *
   */

  renderDetails() {
    let { userRole, entityPlan, easypayReference, users, entity, entityPlans } =
      this.state;
    const noReqMotives = this.state.noReqMotives;
    const forceReqMotives = this.state.forceReqMotives;
    const { id } = this.props.match.params;

    //console.log(this.state.lastControlsRegist);

    return (
      <>
        <ToolsButton showOnlyNotes context_type="EntityNote" context_id={id} />

        <div className="main-reqlist-container">
          <Typography
            variant="h6"
            color="#505e6b"
            gutterBottom
            style={{ marginBottom: "20px" }}
          >
            Geral
          </Typography>
          <EntityMainForm onSubmit={this.updateEntity} entity={entity} />
        </div>

        {userRole === 2 && (entityPlan === null || entityPlan.plan_id === 1) && (
          <div className="delete-entity-container">
            <div className="text-right">
              <Button
                variant="contained"
                size="small"
                onClick={this.showAlertDeleteEntity}
              //onClick={this.deleteEntity}
              >
                Eliminar Entidade
              </Button>
            </div>
          </div>
        )}

        <div className="main-reqlist-container">
          <Grid container>
            <Grid item md={7}>
              <Typography
                variant="h6"
                color="#505e6b"
                gutterBottom
                style={{ marginBottom: "20px" }}
              >
                Controlos
              </Typography>
              {entityPlan && entityPlan.plan_id !== 1 && (
                <FormGroup>
                  <div class="d-flex justify-content-between">
                    <span>
                      <FormControlLabel
                        control={
                          <Switch
                            checked={this.state.disablePayments}
                            onChange={this.changeEasypayReference}
                          />
                        }
                        label="Desativar próximas cobranças"
                      />
                    </span>
                    {this.state.lastControlsRegist &&
                      this.state.lastControlsRegist.map((lastRegist) =>
                        lastRegist.control === "PaymentsControl" ? (
                          <span class="control-update-history">
                            Última atualização por {lastRegist.name} às{" "}
                            {moment(lastRegist.regist).format("HH:mm")} (
                            {moment(lastRegist.regist).format("L")})
                          </span>
                        ) : (
                          ""
                        )
                      )}
                  </div>
                  <div class="small pl-2 text-secondary font-italic">
                    Ao desativar próximas cobranças é automaticamente desativado
                    acesso a pedidos
                  </div>

                  <div className="control-line"></div>

                  <div class="d-flex justify-content-between">
                    {entity && entity.request_mode && (
                      <span>
                        <FormControlLabel
                          control={
                            <Switch
                              checked={this.state.disableAccessToRequests}
                              onChange={this.changePlanDisableDate}
                              id="no_req_id"
                              disabled={entity.request_mode === "auto_accept"}
                            />
                          }
                          label="Desativar acesso a pedidos"
                        />
                      </span>
                    )}
                    {this.state.lastControlsRegist &&
                      this.state.lastControlsRegist.map((lastRegist) =>
                        lastRegist.control === "AccessToRequestsControl" ? (
                          <span class="control-update-history">
                            Última actualização por {lastRegist.name} às{" "}
                            {moment(lastRegist.regist).format("HH:mm")} (
                            {moment(lastRegist.regist).format("L")})
                          </span>
                        ) : (
                          ""
                        )
                      )}
                  </div>
                  <p
                    id="no_req_p"
                    className={
                      this.state.disableAccessToRequests === false
                        ? "d-none"
                        : ""
                    }
                  >
                    Para desativar os pedidos, por favor preencher o motivo
                    primeiro:
                  </p>
                  <FormControl
                    id="no_req_div"
                    className={
                      this.state.disableAccessToRequests === false
                        ? "d-none"
                        : "mb-4"
                    }
                  >
                    <InputLabel id="disable-requests-label">
                      <span className="text-danger">Obrigatório </span>Motivo de
                      desativar acesso a pedidos
                    </InputLabel>
                    {easypayReference && (
                      <Select
                        labelId="disable-requests-label"
                        id="no-requests-select"
                        defaultValue={easypayReference.no_req_motive_id}
                        onChange={this.handleChangeNoReqMotive}
                      >
                        {noReqMotives &&
                          noReqMotives.map((noReqMotive) => (
                            <MenuItem value={noReqMotive.id}>
                              {noReqMotive.motive}
                            </MenuItem>
                          ))}
                      </Select>
                    )}
                    <br />
                  </FormControl>
                  <div className="control-line"></div>
                </FormGroup>
              )}

              <FormGroup>
                <div class="d-flex justify-content-between">
                  <span>
                    <FormControlLabel
                      control={
                        <Switch
                          checked={this.state.acceptDisperseRequests}
                          onChange={this.changeDisperseRequests}
                        />
                      }
                      label="Aceita pedidos dispersos"
                    />
                  </span>
                  {this.state.lastControlsRegist &&
                    this.state.lastControlsRegist.map((lastRegist) =>
                      lastRegist.control === "DispersedRequestsControl" ? (
                        <span class="control-update-history">
                          Última atualização por {lastRegist.name} às{" "}
                          {moment(lastRegist.regist).format("HH:mm")} (
                          {moment(lastRegist.regist).format("L")})
                        </span>
                      ) : (
                        ""
                      )
                    )}
                </div>
                <div className="control-line"></div>

                <div class="d-flex justify-content-between">
                  <span>
                    <FormControlLabel
                      control={
                        <Switch
                          checked={this.state.acceptExclusiveRequests}
                          onChange={this.changeExclusiveRequests}
                        />
                      }
                      label="Aceita pedidos encaminhados"
                    />
                  </span>
                  {this.state.lastControlsRegist &&
                    this.state.lastControlsRegist.map((lastRegist) =>
                      lastRegist.control === "ExclusiveRequestsControl" ? (
                        <span class="control-update-history">
                          Última actualização por {lastRegist.name} às{" "}
                          {moment(lastRegist.regist).format("HH:mm")} (
                          {moment(lastRegist.regist).format("L")})
                        </span>
                      ) : (
                        ""
                      )
                    )}
                </div>
                {this.state.acceptExclusiveRequests &&
                  this.state.forceRequests && (
                    <div class="small pl-2 text-secondary font-italic">
                      Ao desativar "Aceita pedidos encaminhados" é
                      automaticamente desativado "Com potencial de angariação"
                    </div>
                  )}
                <div className="control-line"></div>

                <div class="d-flex justify-content-between">
                  <span>
                    <FormControlLabel
                      control={
                        <Switch
                          checked={this.state.forceRequests}
                          onChange={this.changeForceRequests}
                          id="force_req_btn"
                        />
                      }
                      label="Com potencial de angariação"
                    />
                  </span>
                  {this.state.lastControlsRegist &&
                    this.state.lastControlsRegist.map((lastRegist) =>
                      lastRegist.control === "ForceRequestsControl" ? (
                        <span class="control-update-history">
                          Última atualização por {lastRegist.name} às{" "}
                          {moment(lastRegist.regist).format("HH:mm")} (
                          {moment(lastRegist.regist).format("L")})
                        </span>
                      ) : (
                        ""
                      )
                    )}
                </div>
                {!this.state.forceRequests && (
                  <div class="small pl-2 text-secondary font-italic">
                    Ao ativar "Com potencial de angariação" é automaticamente
                    ativado "Aceita pedidos encaminhados"
                  </div>
                )}
                <p
                  id="force_req_p"
                  className={
                    this.state.forceRequests === false ? "d-none" : "pt-4"
                  }
                >
                  Para ativar a angariação, por favor preencher o motivo
                  primeiro:
                </p>
                <FormControl
                  id="force_req_div"
                  className={
                    this.state.forceRequests === false ? "d-none" : "mb-4"
                  }
                >
                  <InputLabel id="force-requests-label">
                    Motivo de ativar potencial de angariação
                  </InputLabel>
                  {entity && (
                    <Select
                      labelId="force-requests-label"
                      id="force-requests-select"
                      defaultValue={entity.force_req_motive_id}
                      onChange={this.handleChangeForceReqMotive}
                    >
                      {forceReqMotives &&
                        forceReqMotives.map((forceReqMotive) => (
                          <MenuItem value={forceReqMotive.id}>
                            {forceReqMotive.motive}
                          </MenuItem>
                        ))}
                    </Select>
                  )}
                  <br />
                </FormControl>
                <div className="control-line"></div>
                {entityPlan && entityPlan.plan_id !== 1 && (
                  <div class="d-flex justify-content-between">
                    <span>
                      <FormControlLabel
                        control={
                          <Switch
                            checked={this.state.limitEstablishmentsRequests}
                            onChange={this.limitEstablishmentsRequests}
                          />
                        }
                        label="Limitar acesso a 3 pedidos mensais p/ equipamento"
                      />
                    </span>
                    {this.state.lastControlsRegist &&
                      this.state.lastControlsRegist.map((lastRegist) =>
                        lastRegist.control ===
                          "LimitEstablishmentRequestsControl" ? (
                          <span class="control-update-history">
                            Última actualização por {lastRegist.name} às{" "}
                            {moment(lastRegist.regist).format("HH:mm")} (
                            {moment(lastRegist.regist).format("L")})
                          </span>
                        ) : (
                          ""
                        )
                      )}
                  </div>
                )}

                {entityPlan && entityPlan.plan_id !== 1 && easypayReference && (
                  <div>
                    <div className="control-line"></div>
                    <div class="d-flex justify-content-between">
                      <span>
                        <FormControlLabel
                          control={
                            <Switch
                              checked={this.state.freePlan}
                              onChange={this.handleFreePlan}
                            />
                          }
                          label="Plano oferta (avançado grátis)"
                        />
                      </span>
                      {this.state.lastControlsRegist &&
                        this.state.lastControlsRegist.map((lastRegist) =>
                          lastRegist.control === "FreePlanControl" ? (
                            <span class="control-update-history">
                              Última atualização por {lastRegist.name} às{" "}
                              {moment(lastRegist.regist).format("HH:mm")} (
                              {moment(lastRegist.regist).format("L")})
                            </span>
                          ) : (
                            ""
                          )
                        )}
                    </div>
                  </div>
                )}

                {entityPlan && entityPlan.plan_id !== 1 && easypayReference && (
                  <div>
                    <div className="control-line"></div>
                    <div class="d-flex justify-content-between">
                      <span>
                        <FormControlLabel
                          control={
                            <Switch
                              checked={this.state.autoAccept}
                              onChange={this.handleAutoAccept}
                            />
                          }
                          label="Acesso imediato"
                          disabled={
                            easypayReference.disable_plan_at < moment().format()
                          }
                        />
                      </span>
                      {this.state.lastControlsRegist &&
                        this.state.lastControlsRegist.map((lastRegist) =>
                          lastRegist.control === "AutoAcceptControl" ? (
                            <span class="control-update-history">
                              Última atualização por {lastRegist.name} às{" "}
                              {moment(lastRegist.regist).format("HH:mm")} (
                              {moment(lastRegist.regist).format("L")})
                            </span>
                          ) : (
                            ""
                          )
                        )}
                    </div>
                    {this.state.lastControlsRegist &&
                      this.state.lastControlsRegist.map((lastRegist) =>
                        lastRegist.control === "AutoAcceptControl" &&
                          lastRegist.status === 0 ? (
                          <div class="small text-danger">
                            Nota: Esta entidade tinha encaminhamento imediato
                            autorizado. Quando voltar a ter acesso a pedidos,
                            por favor reativar.
                          </div>
                        ) : (
                          ""
                        )
                      )}
                  </div>
                )}
                <div>
                  <div className="control-line"></div>
                  <div className="d-flex justify-content-between">
                    <span>
                      <FormControlLabel
                        control={
                          <Switch
                            checked={!this.state.showElderlyName}
                            onChange={this.handleShowElderlyName}
                          />
                        }
                        label="Esconder nome do idoso"
                      />
                    </span>
                    {this.state.lastControlsRegist &&
                      this.state.lastControlsRegist.map((lastRegist) =>
                        lastRegist.control === "ShowElderlyName" ? (
                          <span className="control-update-history">
                            Última atualização por {lastRegist.name} às{" "}
                            {moment(lastRegist.regist).format("HH:mm")} (
                            {moment(lastRegist.regist).format("L")})
                          </span>
                        ) : (
                          ""
                        )
                      )}
                  </div>
                </div>
              </FormGroup>
            </Grid>

            <Grid item md={5}></Grid>

            <Grid item md={7}>
              <div class="mt-4 mb-4">
                <Button
                  onClick={this.toggleControlsHistory}
                  class="controls-history-btn"
                >
                  Ver histórico de actualizações
                </Button>
              </div>
              <div id="controls-history-description" class="d-none">
                <ul class="controls-history-list">
                  {this.state.entityControlsRegists &&
                    this.state.entityControlsRegists.map((controlRegist) => (
                      <li>
                        [
                        {CONTROL_REGIST_MAP[controlRegist.control] || ""}
                        ]:{" "}
                        {controlRegist.status === 1 ? "Ativado" : "Desativado"}{" "}
                        por {controlRegist.name} às{" "}
                        {moment(controlRegist.regist).format("HH:mm")} em{" "}
                        {moment(controlRegist.regist).format("L")}
                      </li>
                    ))}
                </ul>
                <div class="controls-history-order">
                  <button
                    onClick={this.getHistoryRegistsOrderByControl}
                    class="controls-history-order-btn"
                  >
                    Ordenar por controlo
                  </button>
                </div>
              </div>
            </Grid>
          </Grid>
        </div>

        {/*////////////////////////////////////////////////////////// GRUPOS ////////////////////////////////////////////////////////////////*/}
        <div className="main-reqlist-container">
          <Typography
            variant="h6"
            color="#505e6b"
            gutterBottom
            style={{ marginBottom: "20px" }}
          >
            Grupo
          </Typography>
          {/* entidade com grupo */}
          <div class={this.state.entityGroupId !== null ? "mb-2" : "d-none"}>
            {this.state.entityGroupName && (
              <p>
                Esta entidade pertence ao{" "}
                <a
                  class="entity_group_link"
                  href={"/entity_groups/" + this.state.entityGroupName[0].id}
                >
                  {this.state.entityGroupName[0].name}
                </a>{" "}
              </p>
            )}
          </div>
          {/* entidade sem grupo */}
          <div class={this.state.entityGroupId === null ? "mb-2" : "d-none"}>
            <p>Esta entidade não tem grupo associado. </p>
          </div>
        </div>

        {entityPlan && (
          <div className="main-reqlist-container">
            <Typography
              variant="h6"
              color="#505e6b"
              gutterBottom
              style={{ marginBottom: "20px" }}
            >
              Subscrição
            </Typography>
            <PlanDetailsCard
              entity_plan={entityPlan}
              reference={easypayReference}
            />
          </div>
        )}

        <div className="main-reqlist-container">
          <Typography
            variant="h6"
            color="#505e6b"
            gutterBottom
            style={{ marginBottom: "20px" }}
          >
            Utilizadores
          </Typography>
          {users && (
            <EntityUsersTable
              entity_id={this.props.match.params.id}
              users={users}
              handleAdd={this.createUser}
              handleUpdate={this.updateUser}
              handleDelete={this.deleteUser}
            />
          )}
        </div>

        <div className="main-reqlist-container">
          <Typography
            variant="h6"
            color="#505e6b"
            gutterBottom
            style={{ marginBottom: "20px" }}
          >
            Planos
          </Typography>
          {entityPlans && (
            <EntityPlansTable
              entity_id={this.props.match.params.id}
              plans={entityPlans}
              handleAdd={this.createEntityPlan}
              handleUpdate={this.updateEntityPlan}
              handleDelete={this.deleteEntityPlan}
            />
          )}
        </div>

        <AlertDialog
          open={this.state.showAlert}
          handleClose={this.closeAlert}
          title={this.state.alertTitle}
          message={this.state.alertMessage}
        ></AlertDialog>
      </>
    );
  }

  render() {
    let easypayReference = this.state.easypayReference;
    let entity = this.state.entity;

    return easypayReference !== -1 && entity ? (
      this.renderDetails()
    ) : (
      <div>
        <CircularProgress
          color="secondary"
          style={{ position: "absolute", top: "50%", left: "50%" }}
        />
      </div>
    );
  }
}

export default withRouter(EntitiesView);
